import React, { useContext, useState } from "react";
import DashboardTitleComponent from "../../../../components/layout/Dashboard/Title/DashboardTitleComponent";
import { Tab, Tabs } from "@mui/material";
import BoxComponent from "../../../../components/Box/BoxComponent";
import ButtonComponent from "../../../../components/Button/ButtonComponent";
import { CatalogoComplemento, CatalogoOpcao } from "../../public/CatalogoPage";
import TypographyComponent from "../../../../components/Typography/ThypographyComponent";
import { formatDinheiroToNumber, formatNumberToDinheiro } from "../../../../utils/dinheiro";
import ModalComplemento from "./modal/ModalComplemento";
import { catalogoService } from "../../../../service/CatalogoService";
import { EmpresaContext } from "../../../../provider/empresa/EmpresaContext";
import ModalConfirmComponent from "../../../../components/modal/ModalConfirmComponent";

interface CatalogoAdminComplementosProps {
    tab: number,
    onChangeTab: (opcao: number) => void;
    idEmpresa: number;
    idCategoria: number | undefined;
    /*
    onClickNovoComplemento: () => void;
    onClickNovaOpcao: () => void;
    */

    complementos: CatalogoComplemento[];
    /*
    onClickComplemento: (complemento: CatalogoComplemento) => void;
    onClickInativarComplemento: (complemento: CatalogoComplemento) => void;
    */

    opcoes: CatalogoOpcao[];
    /*
    onClickOpcao: (opcao: CatalogoOpcao) => void;
    onClickInativarOpcao: (opcao: CatalogoOpcao) => void;
    */
    token: string | null;
    updateComplementos: () => Promise<void>;
    updateOpcoes: () => Promise<void>;
}

const cardStyle = {
    //height: '102px',
    backgroundColor: '#F8F5F0',
    border: '1px solid #E8DFD5',
    borderRadius: '8px',
    padding: '12px',
    opacity: 1,

    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    boxSizing: 'border-box'
};

const headerCardStyle = {
    fontFamily: '"Font 7", sans-serif',
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '0%',
    color: '#2C2C2C',
    display: 'inline-flex',
    alignItems: 'center',
    verticalAlign: 'middle'
};

const moneyStyle = {
    fontFamily: '"Font 7", sans-serif',
    fontWeight: 700,
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '0%',
    color: '#FF8C42',
    display: 'inline-flex',
    alignItems: 'center',
    verticalAlign: 'middle'
}

const descriptionStyle = {
    fontFamily: '"Font 7", sans-serif',
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '16px',
    letterSpacing: '0%',
    color: '#999999',
    display: 'inline-flex',
    alignItems: 'center',
    verticalAlign: 'middle'
};

const buttonStyle = {
    width: '100%',
    height: '24px',
    padding: '4px 8px',
    borderRadius: '4px',
    opacity: 1,
    minWidth: 'auto', // Remove a largura mínima padrão do MUI Button

    // Configurações de tipografia
    fontFamily: '"Font 7", sans-serif',
    fontWeight: 500,
    fontSize: '12px',
    lineHeight: '16px',
    letterSpacing: '0%',
    textAlign: 'center',
    textTransform: 'none', // A propriedade que você curte lembrar!

    // Alinhamento estrutural interno
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    verticalAlign: 'middle',
    boxSizing: 'border-box'
};

const flagStyle = {
    width: '67px',
    height: '24px',
    backgroundColor: '#FFE2E2',
    padding: '4px 8px',
    borderRadius: '4px',
    opacity: 1,

    // Configurações de tipografia
    fontFamily: '"Font 7", sans-serif',
    fontWeight: 500,
    fontSize: '12px',
    lineHeight: '16px',
    letterSpacing: '0%',
    color: '#6A7282',

    // Alinhamento do conteúdo interno
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    verticalAlign: 'middle',
    boxSizing: 'border-box'
}

interface OpenModalState {
    open: boolean;
    isComplemento: boolean;
    complemento?: CatalogoComplemento | null;
    isOpcao: boolean;
    opcao?: CatalogoOpcao | null;
}

const CatalogoAdminComplementos = (props: CatalogoAdminComplementosProps) => {
    const { empresa } = useContext(EmpresaContext);

    const [openModal, setOpenModal] = useState<OpenModalState>({
        open: false,
        isComplemento: false,
        complemento: null,
        isOpcao: false,
        opcao: null
    });

    const [modalConfirm, setModalConfirm] = useState({
        open: false,
        isComplemento: false,
        isOpcao: false,
        id: null as number | null
    })

    const renderComplemento = (complemento: CatalogoComplemento, index: number) => {
        const isAtivo = complemento.ativo;
        const isApenasUmItem = complemento.qtdItens === 1;

        return <BoxComponent component="div"
            key={`complemento-${index}`}
            sx={cardStyle}
        >
            <BoxComponent component="div" sx={{ display: "flex", justifyContent: "space-between", gap: 2 }}>
                <TypographyComponent variant="h4" sx={headerCardStyle}>
                    {complemento.nome}
                </TypographyComponent>
                <TypographyComponent variant="body2" sx={moneyStyle}>
                    {formatNumberToDinheiro(complemento.vlrUnitario)}
                </TypographyComponent>
            </BoxComponent>
            <TypographyComponent variant="body2" sx={descriptionStyle}>
                {complemento.qtdItens} {isApenasUmItem ? "produto" : "produtos"}
            </TypographyComponent>
            <TypographyComponent variant="body2" sx={{
                ...flagStyle,
                backgroundColor: isAtivo ? "#D1FAE5" : "#FFE2E2",
                color: isAtivo ? "#016630" : "#DC2626"
            }}>
                {isAtivo ? "Ativo" : "Inativo"}
            </TypographyComponent>
            <BoxComponent component="div" sx={{ display: "flex", justifyContent: "space-between", gap: 1.2 }}>
                <ButtonComponent
                    id={`edit-complemento-${index}`} type="button"
                    sx={{ ...buttonStyle, backgroundColor: "#FF8C42", color: "#FFFFFF" }}
                    onClick={() => openModalComplemento(complemento)}
                >
                    Editar
                </ButtonComponent>
                <ButtonComponent
                    id={`delete-complemento-${index}`} type="button"
                    sx={{ ...buttonStyle, backgroundColor: "#FFE2E2", color: "#DC2626" }}
                    onClick={() => {
                        if (complemento.id) handleOpenDeleteComplemento(complemento.id)
                    }}
                >
                    Inativar
                </ButtonComponent>
            </BoxComponent>
        </BoxComponent>
    }

    const renderOpcao = (opcao: CatalogoOpcao, index: number) => {
        const isAtivo = opcao.ativo;

        return <BoxComponent component="div"
            key={`opcao-${index}`}
            sx={cardStyle}
        >
            <BoxComponent component="div" sx={{ display: "flex", justifyContent: "space-between", gap: 2 }}>
                <TypographyComponent variant="h4" sx={headerCardStyle}>
                    {opcao.nome}
                </TypographyComponent>
                <TypographyComponent variant="body2" sx={flagStyle}>
                    {opcao.tipo}
                </TypographyComponent>
            </BoxComponent>
            <TypographyComponent variant="body2" sx={descriptionStyle}>
                {opcao.descricao}
            </TypographyComponent>
            <TypographyComponent variant="body2" sx={{
                ...flagStyle,
                backgroundColor: isAtivo ? "#D1FAE5" : "#FFE2E2",
                color: isAtivo ? "#016630" : "#DC2626"
            }}>
                {isAtivo ? "Ativo" : "Inativo"}
            </TypographyComponent>
            <BoxComponent component="div" sx={{ display: "flex", justifyContent: "space-between", gap: 1.2 }}>
                <ButtonComponent
                    id={`edit-opcao-${index}`} type="button"
                    sx={{ ...buttonStyle, backgroundColor: "#FF8C42", color: "#FFFFFF" }}
                    onClick={() => openModalOpcao(opcao)}
                >
                    Editar
                </ButtonComponent>
                <ButtonComponent
                    id={`delete-opcao-${index}`} type="button"
                    sx={{ ...buttonStyle, backgroundColor: "#FFE2E2", color: "#DC2626" }}
                    onClick={() => {
                        if (opcao.id) handleOpenDeleteOpcao(opcao.id)
                    }}
                >
                    Inativar
                </ButtonComponent>
            </BoxComponent>
        </BoxComponent>
    }

    const openModalComplemento = (complemento: CatalogoComplemento | null) => {
        setOpenModal({
            open: true,
            isComplemento: true,
            complemento: complemento,
            isOpcao: false,
            opcao: null
        });
    }

    const openModalOpcao = (opcao: CatalogoOpcao | null) => {
        setOpenModal({
            open: true,
            isComplemento: false,
            complemento: null,
            isOpcao: true,
            opcao: opcao
        });
    }

    const handleCloseModal = () => {
        setOpenModal({
            open: false,
            isComplemento: false,
            complemento: null,
            isOpcao: false,
            opcao: null
        });
    }

    const handleSend = async (data: CatalogoComplemento | CatalogoOpcao) => {
        if (!props.token || !props.idCategoria) return;

        const formData = new FormData();

        formData.append("nome", data.nome);
        formData.append("idEmpresa", String(props.idEmpresa));

        if (openModal.isComplemento) {
            if ("vlrUnitarioStr" in data) {
                formData.append(
                    "vlrUnitario",
                    String(formatDinheiroToNumber(data.vlrUnitarioStr || ""))
                );
            }
            var sucesso;

            if (data.id) sucesso = await catalogoService.patchComplemento(
                formData,
                props.idCategoria,
                data.id,
                props.token
            );
            else sucesso = await catalogoService.registerComplemento(
                formData,
                props.idCategoria,
                props.token
            );

            if (sucesso) {
                await props.updateComplementos();
                handleCloseModal();
            }

        } else if (openModal.isOpcao) {
            if ("tipo" in data) {
                formData.append("tipo", data.tipo);
                formData.append("descricao", data.descricao);

                var sucesso;

                if (data.id) sucesso = await catalogoService.patchOpcao(formData, props.idCategoria, data.id, props.token);
                else sucesso = await catalogoService.registerOpcao(formData, props.idCategoria, props.token);

                if (sucesso) {
                    await props.updateOpcoes();
                    handleCloseModal();
                }
            }
        }
    }

    const handleOpenDeleteComplemento = (id: number) => {
        setModalConfirm({
            open: true,
            isComplemento: true,
            isOpcao: false,
            id
        });
    };

    const handleOpenDeleteOpcao = (id: number) => {
        setModalConfirm({
            open: true,
            isComplemento: false,
            isOpcao: true,
            id
        });
    };

    const handleInativaComplemento = async (idComplemento: number) => {
        if (!props.token || !props.idCategoria) return;

        await catalogoService.deleteComplemento(
            props.idEmpresa,
            props.idCategoria,
            idComplemento,
            props.token
        );

        await props.updateComplementos();
    }

    const handleInativaOpcao = async (idOpcao: number) => {
        if (!props.token || !props.idCategoria) return;

        await catalogoService.deleteOpcao(
            props.idEmpresa,
            props.idCategoria,
            idOpcao,
            props.token
        );

        await props.updateOpcoes();
    }

    const closeModalConfirm = () => {
        setModalConfirm({
            open: false,
            isComplemento: false,
            isOpcao: false,
            id: null
        });
    }

    const renderButton = () => {
        const isComplemento = props.tab === 0;
        const isOpcao = props.tab === 1;

        var label = isComplemento ? "Novo Complemento" : "Nova Opção";

        return <ButtonComponent
            id="opcao-complemento-opcao"
            sx={{
                width: "100%",
                height: '36px',
                backgroundColor: '#FF8C42',
                padding: '8px 16px',
                borderRadius: '8px',
                opacity: 1,

                fontFamily: '"Font 7", sans-serif',
                fontWeight: 500,
                fontSize: '14px',
                lineHeight: '20px',
                letterSpacing: '0%',
                textAlign: 'center',
                color: '#FFFFFF',


                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px',
                verticalAlign: 'middle',
                boxSizing: 'border-box',
                textDecoration: "inherit",
                textTransform: 'none'
            }}
            onClick={() => {
                if (isComplemento) openModalComplemento(null);
                else if (isOpcao) openModalOpcao(null);
            }}
        >
            + {label}
        </ButtonComponent>
    }

    const renderComplementos = () => {
        if (props.complementos === null || props.complementos.length === 0) return "Sem registros";

        return props.complementos.map((element: CatalogoComplemento, index: number) => {
            return renderComplemento(element, index);
        });
    };

    const renderOpcoes = () => {
        if (props.opcoes === null || props.opcoes.length === 0) return "Sem registros";

        return props.opcoes.map((element: CatalogoOpcao, index: number) => {
            return renderOpcao(element, index);
        });
    };

    return <>
        <ModalComplemento
            open={openModal.open}
            onClose={handleCloseModal}
            isComplemento={openModal.isComplemento}
            complemento={openModal.complemento}
            isOpcao={openModal.isOpcao}
            opcao={openModal.opcao}
            handleSend={(data: CatalogoComplemento | CatalogoOpcao) => handleSend(data)}
        />

        <ModalConfirmComponent
            open={modalConfirm.open}
            onClose={closeModalConfirm}
            title="Deseja excluir?"
            labelCancelar="Cancelar"
            onClickCancelar={closeModalConfirm}
            labelConfirmar="Sim"
            onClickConfirmar={() => {
                if (modalConfirm.id == null) return;

                if (modalConfirm.isComplemento) {
                    handleInativaComplemento(modalConfirm.id);
                }

                if (modalConfirm.isOpcao) {
                    handleInativaOpcao(modalConfirm.id);
                }

                closeModalConfirm();
            }}
        />

        <Tabs
            value={props.tab}
            onChange={(_, newValue) => props.onChangeTab(newValue)}
            variant="fullWidth"
            sx={{
                display: "flex",
                flexDirection: "column",
                "& .MuiTab-root": {
                    fontFamily: '"Font 7", sans-serif',
                    fontWeight: 600,
                    fontSize: '14px',
                    lineHeight: '20px',
                    letterSpacing: '0%',
                    textAlign: 'center',
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    verticalAlign: 'middle',
                    textTransform: "inherit",
                    color: "#9e9e9e",
                },
                "& .Mui-selected": {
                    color: "#F57C00 !important",
                },
                "& .MuiTabs-indicator": {
                    backgroundColor: "#F57C00",
                    height: 3,
                },
            }}
        >
            <Tab label="Complementos" />
            <Tab label="Opções" />
        </Tabs>

        <BoxComponent component="div"
            sx={{
                display: "flex",
                flexDirection: "column",
                height: "100%",
                overflow: "hidden",
                gap: 2,
                p: 1,
                //width: "100%"
            }}
        >
            <BoxComponent component="div"
                sx={{
                    display: "flex",
                    height: "5%",
                    width: "100%"
                }}
            >
                {renderButton()}
            </BoxComponent>
            <BoxComponent component="div"
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    height: "95%",
                    overflow: "auto",
                    width: "100%",
                    gap: 1.5
                }}
            >
                {props.tab === 0 && renderComplementos()}
                {props.tab === 1 && renderOpcoes()}
            </BoxComponent>
        </BoxComponent>
    </>;
}

export default CatalogoAdminComplementos;